import { DetalleEstadoCuenta } from "@/componentes/ingresos/EstadoCuentaTercero"

/**
 * Anticipos y préstamos en la ficha del empleado (03/11, pedido del usuario): lo que debe y
 * cada movimiento —el préstamo pagado y lo que ha devuelto—, con el saldo después de cada uno.
 *
 * ⚠ **Es el MISMO estado de cuenta de Tesorería → Ingresos → «Cuentas de empleados»**, no una
 * copia: se deriva de los pagos puntuales marcados como anticipo o préstamo y de los ingresos
 * reportados con él como pagador (`services/cuenta_empleado.py`). Pide `ingreso:ver`.
 */
export function CuentaDePersona({ personaId, nombre }: { personaId: number; nombre: string }) {
  return (
    <div className="space-y-3">
      <div>
        <h2 className="text-base font-semibold">Anticipos y préstamos</h2>
        <p className="text-xs" style={{ color: "var(--fg-muted)" }}>
          Se otorgan desde Nómina → pago puntual, marcándolo como anticipo o préstamo, y cuentan al
          pagarse. Lo que devuelve se registra en Tesorería → Ingresos con él como pagador.
        </p>
      </div>
      <DetalleEstadoCuenta tipo="EMPLEADO" id={personaId} nombre={nombre} />
    </div>
  )
}
